package ui.screens.section.brideandgroom.composable

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.cloud_white
import thewedding_cmp.composeapp.generated.resources.flower_pink
import thewedding_cmp.composeapp.generated.resources.photo_1
import thewedding_cmp.composeapp.generated.resources.sun
import ui.screens.section.brideandgroom.cutoutShape
import ui.theme.ColorScheme

@Composable
fun BrideSection(
    textColor: Color,
    imageHeight: Dp,
    imageWidth: Dp,
    decorationSize: Dp,
    decorationSizeX2: Dp,
    safeEntered: Boolean,
) {
    Column {
        Box(
            Modifier.height(imageHeight).fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Image(
                painterResource(Res.drawable.sun),
                modifier = Modifier
                    .align(Alignment.TopCenter)
                    .padding(end = imageWidth / 1.55f)
                    .height(decorationSize)
                    .width(decorationSize),
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.photo_1),
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .height(imageHeight)
                    .width(imageWidth)
                    .border(
                        3.dp,
                        ColorScheme.secondary,
                        cutoutShape
                    )
                    .clip(cutoutShape)
                    .background(Color.White)
                    .padding(8.dp)
                    .border(
                        2.dp,
                        ColorScheme.secondary,
                        cutoutShape
                    )
                    .clip(cutoutShape),
                contentScale = ContentScale.Crop,
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.cloud_white),
                modifier = Modifier
                    .align(Alignment.TopCenter)
                    .padding(start = imageWidth / 1.55f)
                    .height(decorationSize / 1.5f)
                    .width(decorationSizeX2)
                    .alpha(0.8f),
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.flower_pink),
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(start = imageWidth / 1.55f)
                    .height(decorationSize * 1.2f)
                    .width(decorationSize * 1.7f),
                contentDescription = null,
            )
        }

        Text(
            "Eva Aprilia",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 32.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleLarge.copy(
                fontWeight = FontWeight.Normal,
                fontSize = 46.sp,
            ),
            color = textColor,
        )

        Text(
            "Putri dari bapak Tarmuji",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 4.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleSmall.copy(
                fontWeight = FontWeight.Normal,
            ),
            color = textColor,
        )

        Text(
            "& ibu Ngatipah",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 4.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleSmall.copy(
                fontWeight = FontWeight.Normal,
            ),
            color = textColor,
        )
    }
}